import { useMemo, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useProtectedRouteSession } from "../../shared/session/useProtectedRouteSession";
import { OperatorPageScaffold } from "../../shared/ui/protected/OperatorPageScaffold";

const adminLinks = [
  { to: "/t/:tenantSlug/teacher/admin", label: "管理ホーム" },
  { to: "/t/:tenantSlug/teacher/admin/schedule", label: "スケジュール" }
];

function getCurrentYearMonth(): string {
  const today = new Date();
  const year = today.getFullYear();
  const month = String(today.getMonth() + 1).padStart(2, "0");
  return `${year}${month}`;
}

export function AdminScheduleEntryPage() {
  const navigate = useNavigate();
  const { tenantSlug = "unknown-tenant" } = useParams();
  const { routeStatus, sessionStatus, session, errorMessage, isSessionReady } = useProtectedRouteSession(tenantSlug);
  const hasAdminRole = Boolean(session?.member?.roles.includes("admin"));
  const defaultYearMonth = useMemo(() => getCurrentYearMonth(), []);
  const [yearMonth, setYearMonth] = useState(defaultYearMonth);

  function openScheduleMonth(targetYearMonth: string) {
    if (!/^\d{6}$/.test(targetYearMonth)) {
      return;
    }

    navigate(`/t/${tenantSlug}/teacher/admin/schedule-months/${targetYearMonth}`);
  }

  return (
    <OperatorPageScaffold
      currentArea="admin"
      tenantSlug={tenantSlug}
      tenantName={session?.tenant.displayName}
      session={session}
      title="スケジュール管理"
      description="月次スケジュールの再生成・確認・公開を行う入口です。"
      links={adminLinks}
    >
      <div style={{ display: "grid", gap: 16 }}>
        {routeStatus === "checking" || sessionStatus === "loading" ? <p>セッションを確認しています。</p> : null}
        {routeStatus === "redirecting" ? <p>利用開始へ移動しています。</p> : null}
        {sessionStatus === "error" ? <p>セッション確認に失敗しました。{errorMessage}</p> : null}
        {routeStatus === "authenticated" && !hasAdminRole ? <p>この画面は管理者のみ利用できます。</p> : null}

        {isSessionReady && hasAdminRole ? (
          <>
            <div
              style={{
                padding: 12,
                borderRadius: 12,
                border: "1px solid #d7e5ff",
                background: "#f7fbff",
                display: "grid",
                gap: 8
              }}
            >
              <strong>API接続済み</strong>
              <div style={{ fontSize: 14 }}>
                月次スケジュールと予定詳細は Firestore 連携 API に接続済みです。対象月を開いて再生成・確認・公開の流れを確認できます。
              </div>
            </div>

            <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
              <button type="button" onClick={() => openScheduleMonth(defaultYearMonth)}>
                今月を開く
              </button>
            </div>

            <form
              onSubmit={(event) => {
                event.preventDefault();
                openScheduleMonth(yearMonth.trim());
              }}
              style={{ display: "grid", gap: 8 }}
            >
              <label style={{ display: "grid", gap: 4 }}>
                <span>対象月 (YYYYMM)</span>
                <input
                  value={yearMonth}
                  onChange={(event) => setYearMonth(event.target.value)}
                  inputMode="numeric"
                  pattern="\d{6}"
                  placeholder="202604"
                />
              </label>
              <button type="submit">月次スケジュールを開く</button>
            </form>
          </>
        ) : null}
      </div>
    </OperatorPageScaffold>
  );
}
